import React from "react";
import { Box, Grid, styled } from "@mui/material";
import { Title } from "./style";
import GreenHardware from "../../images/partners/green.png";
import Super from "../../images/partners/super.png";
import Yousaf from "../../images/partners/yousaf.png";
import Supreme from "../../images/partners/supreme.png";
import Ufone from "../../images/partners/ufone.png";
import MZ from "../../images/partners/mz.png";
import Hammad from "../../images/partners/hammad.png";
import Logistics from "../../images/partners/logistics.png";
import Fedro from "../../images/partners/fedro.png";
import Ghani from "../../images/partners/al ghani.png";

const RootStyle = styled(Box)(({ theme }) => ({
  background: "#FAFAFA",
  padding: "72px 83px",
  [theme.breakpoints.down("md")]: {
    padding: "30px 15px",
  },
}));
const GridBox = styled(Grid)({
  display: "flex",
  justifyContent: "center",
});

function PartnersSection() {
  return (
    <RootStyle>
      <Title sx={{ mb: { xs: "30px", md: "73px" }, textAlign: "center" }}>
        Our Partners
      </Title>
      <GridBox container spacing={5}>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Ufone} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Supreme} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={MZ} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Hammad} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Logistics} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Fedro} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Yousaf} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={GreenHardware} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Ghani} alt="" />
        </GridBox>
        <GridBox item md={2.2} sm={4} xs={12}>
          <img height="150px" src={Super} alt="" />
        </GridBox>
      </GridBox>
    </RootStyle>
  );
}

export default PartnersSection;
